
import Vue from "vue";
import { Component, Mixins, Prop } from "vue-property-decorator";
import mixin from "./mixin";
import * as modals from "@/lib/modals";
import OrderMap from "@/components/order/OrderMap.vue";
import { getOrderLocation } from "@/utils";

@Component({
  name: modals.mapModal,
  data: () => {
    return {
      customBus: new Vue(),
    };
  },
  components: {
    OrderMap,
  }
})
export default class MapModal extends Mixins(mixin) {
  mapkey: number = 0;
  loadingComplete: boolean = false;

  get ordersWithoutLocation() 
  {
    return this.selectedItems ? this.selectedItems.filter(x => !getOrderLocation(x)) : []
  }

  load()
  {
    this.show();
    this.loadingComplete = true;
  }

  unload()
  {
    this.reset();
  }

  showMap() {
    return this.mapkey > 0 && this.loadingComplete;
  }

  refreshMap() {
    this.mapkey += 1
  }
  reset() {
    this.mapkey = 0;
    this.loadingComplete = false;
  }
}
